import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = {
    product: {
      title: "产品",
      links: [
        { label: "功能介绍", href: "/category/features" },
        { label: "使用指南", href: "/category/guide" },
        { label: "适用场景", href: "/category/scenarios" },
        { label: "用户评价", href: "/category/reviews" },
      ],
    },
    company: {
      title: "公司",
      links: [
        { label: "关于我们", href: "/about" },
        { label: "联系我们", href: "/about#contact" },
        { label: "加入我们", href: "#" },
      ],
    },
    legal: {
      title: "法律",
      links: [
        { label: "隐私政策", href: "#" },
        { label: "服务条款", href: "#" },
      ],
    },
  };

  return (
    <footer className="bg-secondary-500 text-background-50 dark:text-foreground-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-4">hlw</h3>
            <p className="text-sm text-background-50/70 dark:text-foreground-950/70 leading-relaxed">
              让技术更简单。值得信赖的一站式数字化解决方案，助力企业高效构建、部署和管理应用。
            </p>
          </div>

          {Object.entries(footerLinks).map(([key, section]) => (
            <div key={key}>
              <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">{section.title}</h4>
              <ul className="flex flex-col gap-2">
                {section.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-background-50/70 dark:text-foreground-950/70 hover:text-background-50 dark:hover:text-foreground-950 transition-colors duration-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/60 dark:text-foreground-950/60">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/60 dark:text-foreground-950/60 hover:text-background-50 dark:hover:text-foreground-950 transition-colors duration-200" aria-label="微信公众号">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/60 dark:text-foreground-950/60 hover:text-background-50 dark:hover:text-foreground-950 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/60 dark:text-foreground-950/60 hover:text-background-50 dark:hover:text-foreground-950 transition-colors duration-200" aria-label="知乎">
              <i className="ri-zhihu-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}